import React from "react";
import {Switch, Route, BrowserRouter as Router} from 'react-router-dom'
import {Container} from "@material-ui/core";
import HomePage from "./HomePage";
import ErrorPage from "./ErrorPage";
import CoverPage from "./CoverPage";
import {withRouter} from 'react-router';

class PagesContainer extends React.Component {

    render() {
        return (
            <div>
                <Container maxWidth={'md'} style={{marginTop: '80px'}}>
                    <Router>
                        <Switch>
                            <Route exact path="/" component={withRouter(HomePage)}/>
                            <Route exact path="/otulina" component={CoverPage}/>
                        </Switch>
                    </Router>
                </Container>
            </div>
        );
    }
}

export default PagesContainer;